// extracted by mini-css-extract-plugin
export default {"p":"_5791ebbdde _8e50151aab _6150189b7a","clr":"_434b8f33e1","dls":"_5bfff251c5"};